/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import {pxToEm} from "@insticator/insticator-ui";

/* ++++++++++ --------------- Input Form : STYLES --------------- ++++++++++ */
export default {
  inputForm: {
    '& .formelement': {
      border: '2px solid rgb(238, 242, 246)',
      borderRadius: pxToEm(5),
      padding: `0 ${pxToEm(10)}`,
      marginRight: `${pxToEm(4)}`,
      height: pxToEm(48),
      display: 'flex',
      alignItems: 'center',
      background: 'rgb(255, 255, 255)',

      '& input.textfield': {
        border: 'none',
        background: 'none',
        width: '100%',
        outline: 'none'
      },
      '& input[type=number]::-webkit-inner-spin-button, & input[type=number]::-webkit-outer-spin-button': {
        webkitAppearance: 'none',
        mozAppearance: 'none',
        appearance: 'none'
      }
    },
    '& .flexHorizontal': {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      gap: pxToEm(10)
    },
    '& .numberStyle': {
      width: `${pxToEm(80)}`
    },
    '& .numberAlign': {
      textAlign: 'center'
    },
    '& .textStyle': {
      width: `${pxToEm(225)}`
    }
  }
}